import { useEffect, useState } from 'react'
import CustomCheckbox from '../../../../components/Inputs/Checkbox/CustomCheckbox'

interface Options {
    id: number,
    titulo: string,
    count: number,
    disabled?: boolean
}
interface InputProps {
    options: Options[];
    selectedValues?: string[];
    onChange?: (selected: string[]) => void;
}

const Inputs = ({ options, selectedValues = [], onChange }: InputProps) => {
    const [selected, setSelected] = useState<string[]>(selectedValues);

    useEffect(() => {
        setSelected(selectedValues)
    }, [selectedValues])

    const handleToggle = (option: { titulo: string, disabled?: boolean }) => {
        if (option.disabled) return;
        const newSelected = selected.includes(option.titulo)
            ? selected.filter(item => item !== option.titulo)
            : [...selected, option.titulo]

        setSelected(newSelected)
        if (onChange) {
            onChange(newSelected)
        }
    }

    return (
        <div className={`max-h-48  ${options.length > 5 ? 'overflow-y-scroll' : 'overflow-y-auto'}`}>
            {options.map((option, index) => (
                <div
                    className={`mt-4 flex gap-1 ${option.disabled || option.count === 0 ? 'opacity-50 cursor-not-allowed' : ''}`}
                    key={index}
                >
                    <CustomCheckbox
                        id={option.titulo}
                        name={option.titulo}
                        label={option.titulo}
                        checked={selected.includes(option.titulo)}
                        onChange={() => handleToggle(option)}
                        disabled={option.disabled || option.count === 0}
                    />
                    <span className='text-system-light-50'>({option.count})</span>
                </div>
            ))}
        </div>
    )
}

export default Inputs